import type { MatchEvent, TeamResult } from './types'
import { teamId, type TeamId } from './teams'

/** As authored: team **names**. Resolved to canonical team ids at the export below. */
interface RawTeamResult {
  opponent: string
  homeAway: 'H' | 'A'
  score: string
  result: 'W' | 'D' | 'L'
  date: string
  events?: MatchEvent[]
}

const rawMockResults: Record<string, RawTeamResult[]> = {
  'Man Utd': [
    {
      opponent: 'Fulham',
      homeAway: 'H',
      score: '2-1',
      result: 'W',
      date: '2026-06-21',
      events: [
        {
          minute: 12,
          type: 'goal',
          player: 'Rasmus Højlund',
          team: 'home',
          assistBy: 'Bruno Fernandes',
        },
        {
          minute: 34,
          type: 'card',
          player: 'Casemiro',
          team: 'home',
          cardType: 'yellow',
        },
        {
          minute: 58,
          type: 'goal',
          player: 'Raúl Jiménez',
          team: 'away',
          assistBy: 'Andreas Pereira',
        },
        {
          minute: 76,
          type: 'goal',
          player: 'Bruno Fernandes',
          team: 'home',
          note: 'Penalty',
        },
      ],
    },
    {
      opponent: 'Everton',
      homeAway: 'A',
      score: '1-1',
      result: 'D',
      date: '2026-06-14',
    },
    {
      opponent: 'Brighton',
      homeAway: 'H',
      score: '0-2',
      result: 'L',
      date: '2026-06-07',
    },
    {
      opponent: 'Sunderland',
      homeAway: 'A',
      score: '3-0',
      result: 'W',
      date: '2026-05-31',
    },
    {
      opponent: 'Newcastle',
      homeAway: 'H',
      score: '2-0',
      result: 'W',
      date: '2026-05-24',
    },
  ],
  Arsenal: [
    {
      opponent: 'Chelsea',
      homeAway: 'H',
      score: '3-1',
      result: 'W',
      date: '2026-06-21',
    },
    {
      opponent: 'Newcastle',
      homeAway: 'A',
      score: '2-2',
      result: 'D',
      date: '2026-06-14',
    },
    {
      opponent: 'Tottenham',
      homeAway: 'H',
      score: '1-0',
      result: 'W',
      date: '2026-06-07',
    },
    {
      opponent: 'Hull City',
      homeAway: 'A',
      score: '0-1',
      result: 'L',
      date: '2026-05-31',
    },
    {
      opponent: 'Brighton',
      homeAway: 'H',
      score: '3-0',
      result: 'W',
      date: '2026-05-24',
    },
  ],
  Liverpool: [
    {
      opponent: 'Manchester City',
      homeAway: 'A',
      score: '2-1',
      result: 'W',
      date: '2026-06-21',
    },
    {
      opponent: 'Brighton',
      homeAway: 'H',
      score: '1-1',
      result: 'D',
      date: '2026-06-14',
    },
    {
      opponent: 'Chelsea',
      homeAway: 'H',
      score: '2-1',
      result: 'W',
      date: '2026-06-07',
    },
    {
      opponent: 'Everton',
      homeAway: 'A',
      score: '1-1',
      result: 'D',
      date: '2026-05-31',
    },
    {
      opponent: 'Leeds',
      homeAway: 'H',
      score: '3-0',
      result: 'W',
      date: '2026-05-24',
    },
  ],
}

export const mockResults: Record<TeamId, TeamResult[]> = Object.fromEntries(
  Object.entries(rawMockResults).map(([team, results]) => [
    teamId(team),
    results.map((result) => ({ ...result, opponent: teamId(result.opponent) })),
  ])
) as Record<TeamId, TeamResult[]>
